import template from './emailTemplatesSharingPrivacy.html';
import EmailTemplatesSharingPrivacyCtrl from './emailTemplatesSharingPrivacyCtrl';

export default {
  template,
  controller: EmailTemplatesSharingPrivacyCtrl,
};
